import { Controller } from "stimulus"
import "select2"
import swal from "sweetalert2"
import translations from "../../translations"
import * as I18n from "../../services/i18n"
import Error from "../../utils/error.coffee"

export default class extends Controller {
  connect() {
    // Aguardar um pouco para garantir que o DOM esteja carregado
    setTimeout(() => {
      this.initializeSelect2()
      this.bindEvents()
    }, 100)
  }

  initializeSelect2() {
    // Inicializar Select2 no select do modal
    $('#subStrategicStatusSelect').select2({
      theme: 'bootstrap4',
      dropdownParent: $('#editStatusModal')
    })
    
    // Inicializar Select2 nos selects de atribuição
    $('.select-with-select2').each(function() {
      $(this).select2({
        theme: 'bootstrap4'
      })
    })
  }

  bindEvents() {
    // Bind do evento de submit do formulário
    $('#editStatusForm').on('submit', (e) => {
      this.submitForm(e)
    })

    // Bind dos eventos dos filtros
    this.bindFilterEvents()
  }

  bindFilterEvents() {
    // Aplicar filtros ao pressionar Enter nos campos de texto
    $('input[name="entity_filter"], input[name="obra_filter"]').on('keypress', (e) => {
      if (e.which === 13) { // Enter key
        e.preventDefault()
        $(e.target).closest('form').submit()
      }
    })

    // Aplicar filtros automaticamente ao mudar o select de sub-status
    $('select[name="sub_status_filter"]').on('change', (e) => {
      $(e.target).closest('form').submit()
    })
  }

  // Action para abrir o modal quando clicar no botão de editar
  openModal(event) {
    event.preventDefault()
    
    const button = event.currentTarget
    const obraId = button.dataset.obraId
    const obraTitulo = button.dataset.obraTitulo
    const subStrategicStatusId = button.dataset.subStrategicStatusId

    // Preencher dados no modal
    $('#modalTitle').text(obraTitulo)
    
    // Definir URL do formulário
    const formUrl = `/construction_site_status_manager/${obraId}`
    $('#editStatusForm').attr('action', formUrl)

    // Definir sub strategic status
    $('#subStrategicStatusSelect').val(subStrategicStatusId).trigger('change')

    // Mostrar modal
    $('#editStatusModal').modal('show')
  }



  // Action para submeter o formulário
  submitForm(event) {
    event.preventDefault()
    
    const form = $('#editStatusForm')[0]
    const formData = new FormData(form)
    const submitButton = form.querySelector('button[type="submit"]')
    
    // Desabilitar botão de envio
    submitButton.disabled = true
    submitButton.textContent = I18n.t(translations(), 'construction_site_status_manager.index.modal.saving')
    
    // Enviar via fetch
    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      }
    })
    .then(response => {
      if (!response.ok) {
        return response.text().then(text => {
          throw new Error(`HTTP ${response.status}: ${text}`)
        })
      }
      
      return response.json()
    })
    .then(data => {
      // Fechar modal
      $('#editStatusModal').modal('hide')
      
      if (data.status === 'success') {
        Error.show_success_flash_msg(data.message)
        // Recarregar página após um pequeno delay para mostrar a mensagem
        setTimeout(() => {
          location.reload()
        }, 1500)
      } else {
        Error.show_alert_flash_msg(data.message || I18n.t(translations(), 'construction_site_status_manager.index.messages.update_error'))
      }
    })
    .catch(error => {
      Error.show_alert_flash_msg(I18n.t(translations(), 'construction_site_status_manager.index.messages.update_failed'))
    })
    .finally(() => {
      // Reabilitar botão
      submitButton.disabled = false
      submitButton.textContent = I18n.t(translations(), 'construction_site_status_manager.index.modal.save')
    })
  }

  // Action executada quando o modal é fechado
  onModalHidden() {
    // Limpar formulário
    $('#editStatusForm')[0].reset()
    $('#subStrategicStatusSelect').val('').trigger('change')
  }

  // Action para limpar status da obra
  clearStatus(event) {
    event.preventDefault()

    const button = event.currentTarget
    const obraId = button.dataset.obraId
    const obraTitulo = button.dataset.obraTitulo

    swal({
      title: `${I18n.t(translations(), 'form.confirmar')}?`,
      html: I18n.t(translations(), 'construction_site_status_manager.index.messages.confirm_clear'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: I18n.t(translations(), 'form.confirm_yes'),
      cancelButtonText: I18n.t(translations(), 'form.confirm_no'),
    }).then((result) => {
      if (!result.value) return

      // Enviar requisição para limpar status
      fetch(`/construction_site_status_manager/${obraId}/clear_status`, {
        method: 'PATCH',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json',
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`)
        }
        return response.json()
      })
      .then(data => {
        if (data.status === 'success') {
          Error.show_success_flash_msg(data.message)
          setTimeout(() => {
            location.reload()
          }, 1500)
        } else {
          Error.show_alert_flash_msg(data.message || I18n.t(translations(), 'construction_site_status_manager.index.messages.clear_error'))
        }
      })
      .catch(error => {
        Error.show_alert_flash_msg(I18n.t(translations(), 'construction_site_status_manager.index.messages.clear_error_retry'))
      })
    })
  }

  // Action para submeter atribuição de status
  submitAssignment(event) {
    event.preventDefault()
    
    const form = event.target
    const formData = new FormData(form)
    const submitButton = form.querySelector('input[type="submit"]')
    
    // Desabilitar botão de envio
    submitButton.disabled = true

    // Usar I18n se disponível, senão usar fallback
    submitButton.value = I18n.t(translations(), 'construction_site_status_manager.index.assignment.adding_button')

    // Enviar via fetch
    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      }
    })
    .then(response => {
      if (!response.ok) {
        return response.text().then(text => {
          throw new Error(`HTTP ${response.status}: ${text}`)
        })
      }
      
      return response.json()
    })
    .then(data => {
      if (data.status === 'success') {
        // Limpar formulário
        form.reset()
        $('.select-with-select2').val(null).trigger('change')
        
        // Mostrar mensagem de sucesso
        if (typeof Error !== 'undefined' && Error.show_success_flash_msg) {
          Error.show_success_flash_msg(data.message)
        } else {
          alert(data.message || I18n.t(translations(), 'construction_site_status_manager.index.messages.assign_success_fallback'))
        }
        
        // Recarregar página após um pequeno delay
        setTimeout(() => {
          location.reload()
        }, 1500)
      } else {
        const errorMsg = data.message || I18n.t(translations(), 'construction_site_status_manager.index.messages.assign_error_fallback')
        
        if (typeof Error !== 'undefined' && Error.show_alert_flash_msg) {
          Error.show_alert_flash_msg(errorMsg)
        } else {
          alert(errorMsg)
        }
      }
    })
    .catch(error => {
      if (typeof Error !== 'undefined' && Error.show_alert_flash_msg) {
        try {
          const errorMsg = I18n.t(translations(), 'construction_site_status_manager.index.messages.assign_error_retry')
          Error.show_alert_flash_msg(errorMsg)
        } catch (e) {
          Error.show_alert_flash_msg(I18n.t(translations(), 'construction_site_status_manager.index.messages.assign_error_retry'))
        }
      } else {
        alert(I18n.t(translations(), 'construction_site_status_manager.index.messages.assign_error_retry'))
      }
    })
    .finally(() => {
      // Reabilitar botão
      submitButton.disabled = false
      
      // Restaurar texto do botão
      if (typeof I18n !== 'undefined' && typeof translations === 'function') {
        try {
          submitButton.value = I18n.t(translations(), 'construction_site_status_manager.index.assignment.add_button')
        } catch (error) {
          submitButton.value = I18n.t(translations(), 'construction_site_status_manager.index.assignment.add_button')
        }
      } else {
        submitButton.value = I18n.t(translations(), 'construction_site_status_manager.index.assignment.add_button')
      }
    })
  }
} 